import { Box } from '@mui/material';
import { LwButton } from 'redesign';
import { IconAdd } from 'assets/img';
import { generatePath } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const DocumentPageToolbox = () => {
  const { t } = useTranslation('hq-screen-specific');
  const redirectPath = generatePath('issue');

  return (
    <Box display="flex" flex={1} justifyContent="flex-end">
      <LwButton to={redirectPath} startIcon={<IconAdd />} color="primary" iconColorMode="fill">
        {t('document_create.page_title')}
      </LwButton>
    </Box>
  );
};
